import type { PropsWithChildren } from "react";
import { MsalProvider as MsalProviderBase } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "@/shared/config/msal";

export const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.initialize().catch((error) => {
  console.error("MSAL initialization error:", error);
});

export type MsalProviderComponentProps = PropsWithChildren<{
  instance?: PublicClientApplication;
}>;

export function MsalProvider({
  children,
  instance = msalInstance,
}: MsalProviderComponentProps) {
  return <MsalProviderBase instance={instance}>{children}</MsalProviderBase>;
}
